<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Children’s/Family
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>In 2025, <strong>Children's/Family</strong> recorded $70.7m in revenue and attracted close to 1.8m attendances. These results are the second-highest ever recorded for this category (with 2024 being the highest).</p>
          <p><strong>Children's/Family</strong> recorded a y-o-y decline in revenue of 8.4% (from $77.1m in 2024 to $70.7m in 2025) and a y-o-y decline in attendance of 5.4% (from 1.9m in 2024 to 1.8m in 2025). These results show a softening of the <strong>Children's/Family</strong> events market, potentially due to cost-of-living pressures.</p>
          <p>Average ticket prices declined by 0.9% y-o-y (from $46.12 in 2024 to $45.69 in 2025), which also contributed to the decrease in revenue.</p>
          <p>Revenue in this category was primarily driven by events such as <em>Disney on Ice: Find Your Hero</em>, <em>Bluey's Big Play</em>, The Wiggles and <em>Gabby’s Dollhouse Live!</em>.</p>
        </div>
        <div class="sixcol last">
          <p>In 2025, NSW and VIC together generated the most revenue and attendance in this category. These two states combined generated 62.1% of national <strong>Children's/Family</strong> category revenue and 59.4% of attendance in 2025.</p>
          <p>In 2025, NSW, QLD and SA recorded a y-o-y decline in both revenue and attendance, while VIC recorded moderate revenue growth despite a decline in attendance. All other states and territories recorded y-o-y growth in both revenue and attendance.</p>
          <p>NT recorded the highest y-o-y growth in revenue (162.6%) and the second-highest y-o-y growth in attendance (39.3%). The growth in revenue was driven by major performances such as The Wiggles- <em>Bouncing Balls Tour</em>, <em>Such Sweet Sorrow</em> and <em>Macbeth: The Rehearsal</em>. However, its impact is minimal as it represented only 0.6% in revenue and 1.2% in attendance of the overall market share in the <strong>Children's/Family</strong> category.</p>
          <p>ACT recorded the second-highest y-o-y growth in revenue (41.8%) and the third-highest y-o-y growth in attendance (22.1%), driven by major performances such as <em>Bluey's Big Play</em>, The Wiggles, <em>Gabby’s Dollhouse Live!</em> and <em>Storytime: The Sleeping Beauty</em>.</p>
          <p>TAS recorded the third-highest y-o-y growth in revenue (39.9%) and highest y-o-y growth in attendance (91.1%). The growth in revenue was driven by major performances such as The Wiggles, <em>Gabby’s Dollhouse Live!</em> and <em>Goldfish</em>.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="children-family-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>
        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.<br>Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
        </div>
      </div>
    </figure>

    <div class="row clearfix">
      <h2 id="download-btn">Download the Report</h2>
      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/CHILDRENS AND FAMILY EVENTS  Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          Children’s/Family Infographic Report 2025 (PDF)
        </a>
      </div>
    </div>

    <div class="fullbg">
      <p class="caption">Photo: <em>Whirlwind</em>, Polyglot Theatre presented by Melbourne Fringe, Photo Credit: Laura May Grogan</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter () {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          backgroundColor: '#FFFFFF'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [10.738, 43.109, 30.944, 46.535, 45.647, 31.905, 31.248, 58.777, 51.587, 38.684, 43.432, 38.368, 54.316, 51.308, 59.778, 43.649, 10.397, 34.298, 48.054, 67.82, 77.149, 70.677],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [0.515, 1.271, 1.114, 1.394, 1.455, 1.076, 0.975, 1.453, 1.3, 1.091, 1.214, 1.081, 1.376, 1.306, 1.651, 1.172, 0.378, 1.051, 1.488, 1.71, 1.896, 1.795],
          color: '#d14967'
        }]
      },
      activeYear: 2025,
      stateBreakdowns: [
        {
          year: 2025,
          revenue: [
            ["NSW", 34.2],
            ["VIC", 27.9],
            ["QLD", 15.0],
            ["WA", 10.9],
            ["SA", 6.1],
            ["ACT", 3.7],
            ["TAS", 1.5],
            ["NT", 0.6],
          ],
          attendance: [
            ["NSW", 35.5],
            ["VIC", 23.9],
            ["QLD", 14.7],
            ["WA", 12.3],
            ["SA", 6.4],
            ["ACT", 3.4],
            ["TAS", 2.6],
            ["NT", 1.2],
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [
              {
                name: 'Attendance Share',
                data: stateBreakdown.attendance,
                size: '68%',
                innerSize: '40%',
                borderColor: 'none',
                borderWidth: 1,
                slicedOffset: 30,
                showInLegend: true,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -28
                }
              }, 
              {
                name: 'Revenue Share',
                data: stateBreakdown.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -32
                }
              }
            ],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("~@/assets/img/2025/19-Childrens-Family-2025-IMAGE-Whirlwind-Immigration-Museum-Photographer-Laura-May-Grogan-HR-3400-Crop.jpg");}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
